import { useNavigate, useParams } from 'react-router-dom'

import PageHeader from '../components/page-header'

import { CheckboxField, PasswordField, TextField } from './fields'
import SelectField from './fields/select-field'
import FormWrapper from './form-wrapper'

export default function UserForm(props) {
    const params = useParams()
    const navigate = useNavigate()
    let id = params.id ?? props.id

    return (
        <div>
            <PageHeader headline='Manage User'></PageHeader>
            <FormWrapper url='admin/user' id={id} {...props} callback={() => navigate(-1)}>
                {(values, setValues) => (
                    <>
                        <TextField label='First Name' value={values.name} onChange={(val) => setValues({ ...values, name: val })}></TextField>
                        <TextField label='Last Name' value={values.lastName} onChange={(val) => setValues({ ...values, lastName: val })}></TextField>
                        <TextField label='Email' value={values.email} onChange={(val) => setValues({ ...values, email: val })}></TextField>
                        <CheckboxField label='Is Merchant' value={values.isMerchant} onChange={(val) => setValues({ ...values, isMerchant: val })} />

                        <SelectField
                            label='Subscription Type'
                            value={values.subscriptionType}
                            onChange={(val) => setValues({ ...values, subscriptionType: val })}
                            options={[
                                { text: 'Standard', value: 'standard' },
                                { text: 'Plus', value: 'standard_premium' },
                                { text: 'Family Plus', value: 'family_premium' },
                            ]}
                        />

                        <PasswordField label='New Password' value={values.password} onChange={(val) => setValues({ ...values, password: val })}></PasswordField>
                    </>
                )}
            </FormWrapper>
        </div>
    )
}
